// extracted by mini-css-extract-plugin
module.exports = {"root":"VerticalTable_root__iVFDb"};